import type { HelpFile } from '../../types/help'
import { IdentitySnapshotViewTestIds } from '../../../testids/IdentitySnapshotViewTestIds'

export const identitySnapshotViewHelp: HelpFile = {
  docPage: '/docs/identity/identities',
  texts: {
    [IdentitySnapshotViewTestIds.colAttributeName]: null,
    [IdentitySnapshotViewTestIds.colAttributeObserved]: 'Zeitstempel der letzten Beobachtung dieses Attributwerts aus einem Quellsystem.',
    [IdentitySnapshotViewTestIds.colAttributeType]: null,
    [IdentitySnapshotViewTestIds.colAttributeValue]: null,
    [IdentitySnapshotViewTestIds.colIdentifierPrimary]: 'Gibt an, ob dieser Identifikator der primäre Identifikator der Identität ist.',
    [IdentitySnapshotViewTestIds.colIdentifierType]: 'Art des Identifikators, z. B. E-Mail, Personalnummer oder UPN.',
    [IdentitySnapshotViewTestIds.colIdentifierValidFrom]: null,
    [IdentitySnapshotViewTestIds.colIdentifierValue]: 'Wert des Identifikators, wie ihn das Quellsystem kennt.',
  },
}
